import {Grid, Skeleton, SkeletonPropsVariantOverrides} from "@mui/material";
import {OverridableStringUnion} from "@mui/types";

interface SkeletonProps {
    howMany: number;
    type: OverridableStringUnion<"text" | "rectangular" | "rounded" | "circular", SkeletonPropsVariantOverrides>;
    gap?: number;
    styles?: {
        [key: string]: string
    }
}

const CustomSkeleton = ({howMany, type, styles, gap = 1}: SkeletonProps) => {
    const arr = [...Array(howMany)].map((_, i) => 1 + i);
    return <Grid className="df we1 fdc" gap={gap}>
        {arr.map((index: number) => <Skeleton variant={type} key={`SKE-${index}`}
                                              sx={{width: "100%", marginTop: "1rem", height: "2rem", ...styles}}/>)}
    </Grid>
}

export default CustomSkeleton